import React, { Suspense } from 'react';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';
import {
  LinkButton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { useCaptureEventOnMount } from '@eluve/posthog-react';
import {
  useIsEluveAdmin,
  useIsPromptTemplateCreator,
} from '@eluve/session-helpers';

import { TenantOutputTemplatesList } from './TenantOutputTemplatesList';

export interface TenantOutputTemplatesListPageProps {}

export const TenantOutputTemplatesListPage: React.FC<
  TenantOutputTemplatesListPageProps
> = () => {
  useCaptureEventOnMount('page_view_output_templates_list');
  const { t } = useTranslation();
  const isTemplateCreator = useIsPromptTemplateCreator();
  const isEluveAdmin = useIsEluveAdmin();

  const isCreateTemplateDisabled = !(isEluveAdmin || isTemplateCreator);

  return (
    <SettingsPageFrame
      size="wide"
      title={t('outputTemplates.common.templates')}
      actions={
        <Tooltip>
          <TooltipTrigger asChild>
            <LinkButton
              to="create"
              size="sm"
              disabled={isCreateTemplateDisabled}
            >
              {t('outputTemplates.common.createTemplate')}
            </LinkButton>
          </TooltipTrigger>
          {isCreateTemplateDisabled && (
            <TooltipContent>
              {t('outputTemplates.common.noCreatePermission')}
            </TooltipContent>
          )}
        </Tooltip>
      }
    >
      <Suspense fallback={<TableSkeleton rowCount={20} />}>
        <TenantOutputTemplatesList />
      </Suspense>
    </SettingsPageFrame>
  );
};
